import * as React from 'react';
import {Helmet} from 'react-helmet';
import {Link} from 'react-router-dom';

import {List} from '@common/typescript/objects/List';

import {ContentEntity, ContentType} from '@app/objects/ContentTopic';
import ModalVideo from '@app/components/UI/ModalVideo/ModalVideo';
import {TEXT_LINK, ICON_LINK} from '@app/components/Pages/Resources/FamilyResources/FRUtils';
import {rest} from '@app/components/Api';
import withSeo from '@app/components/LocalCommon/HigherOrderComponents/WithSeo';

const FRBlog = ({
	currentCategoryBlog,
	match,
	categoriesBlog,
	onSetCategory,
	searchQuery
}) => {
	const [contentTopicList, setContentTopicList] = React.useState<ContentEntity[]>();
	const [offsetContent, setOffsetContent] = React.useState<number>(0);
	const [modalVisible, setModalVisible] = React.useState(false);
	const [videoSrc, setVideoSrc] = React.useState('');
	const [blogItemsTotalCount, setBlogItemsTotalCount] = React.useState<number>(0);
	const [isLoaded, setIsLoaded] = React.useState<boolean>(false);
	const initBlogItemsCount  = 10;

	const increaseOffsetContent = (count) => {
		setOffsetContent(offsetContent + count);
	};

	React.useEffect(() => {
		let url;
		if (!currentCategoryBlog?.url) {
			if (match.params.id) {
				if (categoriesBlog) {
					categoriesBlog.forEach((item) => {
						if (item.url === match.params.id) {
							onSetCategory(item);
							return false;
						}
					});
				}
				url = `v2/contentTopics/blog/${match.params.id || ''}/content?text=${searchQuery || ''}${offsetContent ? `&offset=${offsetContent}` : ''}`;
			} else {
				url = `v2/contentTopics/blog/content?text=${searchQuery || ''}${offsetContent ? `&offset=${offsetContent}` : ''}`;
			}
		} else {
			url = `v2/contentTopics/blog/${currentCategoryBlog?.url}/content?text=${searchQuery || ''}${offsetContent ? `&offset=${offsetContent}` : ''}`;
		}
		rest.get<List<ContentEntity>>(url)
			.then((res) => {
				offsetContent ?
					setContentTopicList(prev => prev ? [...prev, ...res.list] : res.list) :
					setContentTopicList(res.list);
				setBlogItemsTotalCount(res.count);
				setIsLoaded(true);
			});
	}, [currentCategoryBlog, offsetContent, searchQuery]);

	React.useEffect(() => {
		setOffsetContent(0);
	}, [currentCategoryBlog]);

	return (
		<>
			{currentCategoryBlog &&
			<Helmet>
				<title>{`${currentCategoryBlog.name || 'Blog'} | Lap of Love`}</title>
				<meta name="description" property="og:description" content={currentCategoryBlog.description || undefined}/>
			</Helmet>
			}
			<div className="blog-page__content">
				{!isLoaded ? <div className="faq-block__dummy">Woof! Looks like we're still loading a few things.</div> : 
					contentTopicList && contentTopicList.length ?
					contentTopicList.map((item, index) => (
						<article key={index} className="article">
							<div className="article__info">
								<h6 className="article__caption">{item.title}</h6>
								<p className="article__text">{item.smallText}</p>
								<div className="article__addition">
									{item.contentType === ContentType.Video ?
										<span onClick={() => {
											setModalVisible(true);
											setVideoSrc(item.url);
										}} className="article__more btn-text">
												{TEXT_LINK[item.contentType]} <img className="arrow-icon" src={ICON_LINK[item.contentType]} alt="Arrow"/>
											</span> :
										(item.contentType === ContentType.Article ?
												<Link
													to={`/blog/${item.topic.url}/${item.url}`}
													className="article__more btn-text"
												>
													{TEXT_LINK[item.contentType]} <img className="arrow-icon" src={ICON_LINK[item.contentType]} alt="Arrow"/>
												</Link> :
												<a href={item.url} className="article__more btn-text" target={'_blank'}>
													{TEXT_LINK[item.contentType]} <img className="arrow-icon" src={ICON_LINK[item.contentType]} alt="Arrow"/>
												</a>
										)
									}
	
									<span className="article__name-date">
										{currentCategoryBlog?.name || item.topic?.name}
									</span>
								</div>
							</div>
							<div className="article__photo" style={{backgroundImage:  `url(${item.avatar})`}}/>
						</article>
					)) : <div className="faq-block__dummy">Woof! We were not able to find a match. Please try another search.</div>
				}

				{contentTopicList && blogItemsTotalCount > contentTopicList.length &&
				<div className="text-center">
					<button className="btn btn-lg btn-secondary blog-page__load-more" onClick={() => {
						increaseOffsetContent(10);
					}}>
						Load more
					</button>
				</div>
				}
			</div>

			<ModalVideo
				modalVisible={modalVisible}
				setModalVisible={setModalVisible}
				videoSrc={videoSrc}
			/>
		</>

	);
};

export default withSeo(FRBlog, state => state.blogPage, 'blogPage', 'blog');